import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import AdminPaymentMethodRow from './adminPaymentMethodRow';
import Helmet from 'react-helmet';
import { usePaymentMethods } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import utils from '../../utils/utils';
import CustomPaginator from '../../components/paginator';
import { Link } from 'react-router-dom';

const RESULTS_PER_PAGE = 50;

const AdminPaymentMethods = () => {
  const [sortBy, setSortBy] = useState('idDesc');
  const [activePage, setActivePage] = useState(1);

  const {
    isLoading: loading,
    result,
    isError,
    error,
    refetch,
  } = usePaymentMethods({
    sortBy,
    max: RESULTS_PER_PAGE,
    offset: (activePage - 1) * RESULTS_PER_PAGE,
    className: 'PaymentMethodInvoice',
  });

  useEffect(() => {
    refetch();
  }, [sortBy, activePage]);

  function setSortMethod(newSortBy) {
    let sortParam;

    switch (newSortBy) {
      case 'id':
      default:
        sortParam = sortBy === 'idAsc' ? 'idDesc' : 'idAsc';
    }

    setSortBy(sortParam);
  }

  const { formatMessage } = useIntl();

  const paginator = (
    <div className="m-b-3 m-t-3">
      <CustomPaginator
        activePage={activePage}
        resultsPerPage={RESULTS_PER_PAGE}
        setActivePage={(newNumber) => {
          if (newNumber !== activePage) {
            setActivePage(newNumber);
          }
        }}
        totalCount={result?.totalCount || 0}
      />
    </div>
  );

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.payment.methods.title' })}</title>
      </Helmet>
      <h3>
        <FormattedMessage id={'admin.payment.methods.title'} />
      </h3>

      <div className="m-b-3">
        <Link className="btn btn-default" to="/admin/paymentMethods/create">
          <FormattedMessage id={'admin.button.create'} />
        </Link>
      </div>

      <Loader show={loading} />
      {isError ? <ErrorMessage error={utils.getErrorMessageFromResponse(error)} /> : ''}

      {paginator}

      <table className="table table-striped admin__table admin__table m-bottom-margin">
        <thead>
          <tr>
            <th onClick={() => setSortMethod('id')} className="sortable" scope="col">
              ID
            </th>
            <th scope="col">Business</th>
            <th scope="col">Limit</th>
            <th scope="col">Is primary</th>
            <th scope="col">Created by</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {result?.paymentMethods.map((paymentMethod, index) => (
            <AdminPaymentMethodRow paymentMethod={paymentMethod} key={index} />
          ))}
        </tbody>
      </table>

      {paginator}
    </div>
  );
};

export default AdminPaymentMethods;
